import { useSelector } from "react-redux";
import { array } from "prop-types";

const useRole = () => useSelector(({ auth }) => auth.userRole);

const isUserAdmin = (roles) => roles.includes("admin");
const isUserStudent = (roles) => roles.includes("student");
const isUserEnlistor = (roles) => roles.includes("enlistor");
const isUserMsp = (roles) => roles.includes("msp");
const isUserLeasor = (roles) => roles.includes("hire");
const isUserFarmer = (roles) => roles.includes("farmer");
const isUser = (roles) => roles.includes("user");
const isUserOperator = (roles) => roles.includes("operator");
const isUserAgent = (roles) => roles.includes("agent");
const isUserInvestor = (roles) => roles.includes("investor");

isUserAdmin.propTypes = {
  roles: array,
};
isUserStudent.propTypes = {
  roles: array,
};
isUserEnlistor.propTypes = {
  roles: array,
};
isUserMsp.propTypes = {
  roles: array,
};
isUserLeasor.propTypes = {
  roles: array,
};
isUserFarmer.propTypes = {
  roles: array,
};
isUser.propTypes = {
  roles: array,
};
isUserOperator.propTypes = {
  roles: array,
};
isUserAgent.propTypes = {
  roles: array,
};
isUserInvestor.propTypes = {
  roles: array,
};

export {
  useRole,
  isUserAdmin,
  isUserAgent,
  isUser,
  isUserMsp,
  isUserEnlistor,
  isUserFarmer,
  isUserInvestor,
  isUserOperator,
  isUserStudent,
  isUserLeasor,
};
